class BrandsListing extends HTMLElement {
  connectedCallback() {
    const script = this.querySelector('script[type="application/json"]');
    if (!script) return;
    this.brands = JSON.parse(script.textContent);
    this.brands.sort((a, b) => a.name.localeCompare(b.name));
    this.grouped = this.groupByLetter(this.brands);
    this.allLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    this.activeLetters = new Set(Object.keys(this.grouped));
    script.remove();
    this.render();
    this.attachListeners();
  }
  groupByLetter(brands) {
    const groups = {};
    brands.forEach((brand) => {
      const letter = brand.name.charAt(0).toUpperCase();
      const key = /[A-Z]/.test(letter) ? letter : "#";
      if (!groups[key]) groups[key] = [];
      groups[key].push(brand);
    });
    return groups;
  }
  render() {
    this.innerHTML = `
      <div class="brands-search mb-6">
        <input
          type="text"
          placeholder="Search brands..."
          class="border-gray-border w-full rounded-2xl border px-6 py-3 text-base outline-none focus:border-black"
          data-brands-search
        >
      </div>

      <div class="brands-alphabet sticky top-[calc(var(--height-nav)+1rem)] z-20 mb-8 flex flex-wrap gap-1 bg-white py-2 md:gap-2">
        ${this.allLetters.map((letter) => {
      const hasResults = this.activeLetters.has(letter);
      return `<button
              type="button"
              data-letter="${letter}"
              class="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-border bg-white text-sm font-semibold transition-colors ${hasResults ? "cursor-pointer hover:bg-[#D7EEE6] hover:border-[#D7EEE6]" : "cursor-default text-gray-300"}"
              ${hasResults ? "" : "disabled"}
            >${letter}</button>`;
    }).join("")}
      </div>

      <div class="brands-groups" data-brands-groups>
        ${this.renderGroups(this.grouped)}
      </div>

      <div class="brands-empty mt-8 hidden text-center text-gray-500" data-brands-empty>
        No brands found
      </div>
    `;
  }
  renderGroups(grouped) {
    const sortedKeys = Object.keys(grouped).sort();
    return sortedKeys.map(
      (letter) => `
        <div class="brands-group mb-8" id="brand-letter-${letter}" data-brand-group="${letter}">
          <div class="mb-4 flex items-center gap-4 text-2xl font-bold">
            <span class="brand-letter-heading flex h-10 w-10 items-center justify-center rounded-lg transition-colors" data-letter-heading="${letter}">${letter}</span>
            <div class="h-px flex-1 bg-gray-200"></div>
          </div>
          <div class="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
            ${grouped[letter].map(
        (brand) => `
                <a
                  href="${brand.url}"
                  class="border-gray-border flex items-center gap-3 rounded-2xl border px-5 py-3 font-medium transition-colors hover:border-primary"
                  data-brand-name="${brand.name.toLowerCase()}"
                >
                  ${brand.img_url ? `<img src="${brand.img_url}" alt="${brand.name}" width="50" height="50" class="h-12.5 w-12.5 shrink-0 rounded-lg object-contain" loading="lazy">` : `<span class="flex h-12.5 w-12.5 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-lg font-bold text-gray-400">${brand.name.charAt(0)}</span>`}
                  ${brand.name}
                </a>
              `
      ).join("")}
          </div>
        </div>
      `
    ).join("");
  }
  attachListeners() {
    const searchInput = this.querySelector("[data-brands-search]");
    const groupsContainer = this.querySelector("[data-brands-groups]");
    const emptyState = this.querySelector("[data-brands-empty]");
    searchInput.addEventListener("input", () => {
      const query = searchInput.value.toLowerCase().trim();
      if (!query) {
        groupsContainer.innerHTML = this.renderGroups(this.grouped);
        emptyState.classList.add("hidden");
        this.updateAlphabetState(this.activeLetters);
        return;
      }
      const filtered = this.brands.filter(
        (b) => b.name.toLowerCase().includes(query)
      );
      const filteredGrouped = this.groupByLetter(filtered);
      groupsContainer.innerHTML = this.renderGroups(filteredGrouped);
      const hasResults = filtered.length > 0;
      emptyState.classList.toggle("hidden", hasResults);
      this.updateAlphabetState(new Set(Object.keys(filteredGrouped)));
    });
    this.querySelector(".brands-alphabet").addEventListener("click", (e) => {
      const btn = e.target.closest("[data-letter]");
      if (!btn || btn.disabled) return;
      const letter = btn.dataset.letter;
      const target = this.querySelector(`#brand-letter-${letter}`);
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top, behavior: "smooth" });
      }
      this.querySelectorAll(".brands-alphabet button").forEach((b) => {
        b.classList.remove("bg-[#D7EEE6]", "border-[#D7EEE6]");
        b.classList.add("bg-white", "border-gray-border");
      });
      btn.classList.remove("bg-white", "border-gray-border");
      btn.classList.add("bg-[#D7EEE6]", "border-[#D7EEE6]");
      this.querySelectorAll(".brand-letter-heading").forEach((h) => {
        h.classList.remove("bg-primary", "text-white");
      });
      const heading = this.querySelector(`[data-letter-heading="${letter}"]`);
      if (heading) heading.classList.add("bg-primary", "text-white");
    });
  }
  updateAlphabetState(activeSet) {
    this.querySelectorAll(".brands-alphabet button").forEach((btn) => {
      const letter = btn.dataset.letter;
      const hasResults = activeSet.has(letter);
      btn.disabled = !hasResults;
      btn.classList.toggle("text-gray-300", !hasResults);
      btn.classList.toggle("cursor-default", !hasResults);
      btn.classList.toggle("cursor-pointer", hasResults);
      if (!hasResults) {
        btn.classList.remove("bg-[#D7EEE6]", "border-[#D7EEE6]");
        btn.classList.add("bg-white", "border-gray-border");
      }
    });
  }
}
customElements.define("brands-listing", BrandsListing);
